import React, { useEffect } from 'react';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import styled from 'styled-components';
import deleteIcon from '../../../asset/icon/delete.png';
import { WorkSortOrder } from '../../../shared/enum/EnumRepository';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import { useWorkPropertyVisible } from '../../../shared/hooks/useApi/useWorkPropertyVisible';
import { useWorkViewStore } from '../../../shared/store/WorkViewStore';
import BlockWithSortVisible from '../BlockWithSortVisible';
import WorkOverviewEditActions from '../WorkOverviewEditActions';

const AttributedColumnInfoMobile: React.FC = () => {
  const { isEditMode } = useEditMode();
  const { workPropertyVisible, getWorkPropertyVisible } = useWorkPropertyVisible();
  const activeWork = useWorkViewStore((s) => s.activeWork);
  const setActiveWork = useWorkViewStore((s) => s.setActiveWork);

  useEffect(() => {
    void getWorkPropertyVisible();
  }, []);

  if (!workPropertyVisible) return null;

  return (
    <ColumnInfoComp>
      <InfoContainer $isActive={!!activeWork}>
        <ImageBlock />
        <BlockWithSortVisible
          width="1.5"
          isColumn
          align="left"
          paddingLeft="6px"
          field={WorkSortOrder.ARTIST_NAME}
          value="Name"
        />
        <BlockWithSortVisible
          width="2.5"
          isColumn
          field={WorkSortOrder.TITLE}
          value="Title"
        />
        <BlockWithSortVisible
          width="1.1"
          isColumn
          field={WorkSortOrder.YEAR}
          value="Year"
        />
      </InfoContainer>
      {activeWork && (
        <OverviewBlock>
          <OverviewText>Overview</OverviewText>
          <OverviewActions>
            <WorkOverviewEditActions />
            {!isEditMode && (
              <UniversalIconBtn
                size="small"
                border={false}
                isTransparent
                backgroundImg={deleteIcon}
                onClick={() => setActiveWork(null)}
              />
            )}
          </OverviewActions>
        </OverviewBlock>
      )}
    </ColumnInfoComp>
  );
};

export default AttributedColumnInfoMobile;

const ColumnInfoComp = styled.article`
  width: 100%;
  height: 36px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_02};
  ${({ theme }) => theme.typography.Body_03_1};
`;

const InfoContainer = styled.article<{ $isActive: boolean }>`
  width: ${({ $isActive }) => $isActive ? '0%' : '100%'};
  opacity: ${({ $isActive }) => $isActive ? 0 : 1};
  overflow-x: hidden;
  height: 32px;
  display: flex;
  transition: all 0.7s ease-in-out;
`;

const ImageBlock = styled.div`
  flex: 0.6;
  min-width: 40px;
  max-width: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-right: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

const OverviewBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const OverviewText = styled.div`
  display: flex;
`;

const OverviewActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
